module.exports = __webpack_public_path__ + "img/beer_id-3.364ecc4a.jpg";